<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t(getLabel('Class')) + ' *'"
              :invalid-feedback="$t(getLabel('Class') + ' is required')"
              ref="class"
            >
              <v-select
                v-model="timetable.clsID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                :reduce="(val) => val.id"
                label="name"
                ref="class"
                @input="FillSections()"
                @search:blur="CheckClass()"
                :disabled="dataloading"
                :placeholder="$t('Select ' + getLabel('class'))"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t(getLabel('Section')) + ' *'"
              :invalid-feedback="$t(getLabel('Section') + ' is required')"
              ref="section"
            >
              <v-select
                ref="section"
                v-model="timetable.section"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="admittedSections"
                :reduce="(val) => val.id"
                label="section"
                :clearable="false"
                :disabled="dataloading"
                @input="CheckSection()"
                :placeholder="$t('Select ' + getLabel('section'))"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Subject') + ' *'"
              :invalid-feedback="$t('Subject is required.')"
              ref="subject"
            >
              <v-select
                ref="subject"
                v-model="timetable.subID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="subjects"
                :reduce="(val) => val.id"
                label="subject"
                :clearable="false"
                :disabled="dataloading"
                @input="CheckSubject()"
                :placeholder="$t('Select subject')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              v-if="adding"
              :label="$t('Days') + ' *'"
              :invalid-feedback="$t('Days are required.')"
              ref="days"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                ref="days"
                v-model="myObj.days"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="alldays"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                :disabled="dataloading"
                @input="CheckDays()"
                :placeholder="$t('Select days.')"
              />
            </b-form-group>
            <b-form-group
              v-else
              :label="$t('Day') + ' *'"
              :invalid-feedback="$t('Day is required.')"
              ref="editDay"
            >
              <v-select
                ref="editDay"
                v-model="timetable.day"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="alldays"
                :reduce="(opt) => opt.value"
                label="text"
                :clearable="false"
                :disabled="dataloading"
                @input="CheckDays()"
                :placeholder="$t('Select days.')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Start Time') + ' *'"
              :invalid-feedback="$t('Start time is required.')"
              ref="startTime"
            >
              <b-form-input
                :placeholder="$t('Enter start time.')"
                ref="startTime"
                @input="CheckStartTime()"
                v-model.trim="timetable.startTime"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('End Time') + ' *'"
              :invalid-feedback="$t('End time is required.')"
              ref="endTime"
            >
              <b-form-input
                :placeholder="$t('Enter end time.')"
                ref="endTime"
                @input="CheckEndTime()"
                v-model.trim="timetable.endTime"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <b-row align-h="end">
        <b-col cols="2">
          <b-button
            @click="back()"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
          >
            <feather-icon icon="ChevronLeftIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Back") }}</span>
          </b-button>
        </b-col>
        <b-col
          class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1 text-right"
          cols="10"
        >
          <b-button
            class="mx-50"
            v-for="(d, ind) in days"
            :key="ind"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="current == d.value ? 'primary' : 'outline-primary'"
            @click="LoadData(d.value)"
          >
            {{ $t(d.text) }}
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-button
            @click="AddOpen()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Add Time Table") }}</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
      >
        <template #empty="scope">
          <h3 class="mt-1 mb-1 text-center">
            {{ $t("No records found") }}
          </h3>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>
        <template #cell(name)="data">
          <b-badge variant="light-primary">
            {{ data.item.name }}
          </b-badge>
        </template>
        <template #cell(section)="data">
          <b-badge variant="light-primary">
            {{ data.item.section }}
          </b-badge>
        </template>
        <template #cell(subject)="data">
          <b-badge variant="light-primary">
            {{ data.item.subject }}
          </b-badge>
        </template>

        <template #head()="scope">
          <div>
            <span>{{ $t(getLabel(scope.label)) }}</span>
          </div>
        </template>

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ $t(data.label) }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Edit(data.item.obj)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Delete(data.item.obj)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["id"],
  components: {
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    // console.log(this.$route.params.id);
    this.LoadData("monday");
    this.LoadInfo();
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    isHappiness() {
      return this.reportDomain == "myskoolhappinessfoundation";
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      myDepartments: [],
      request: false,
      visibility1: false,
      days: [
        { text: "Mon", value: "monday" },
        { text: "Tue", value: "tuesday" },
        { text: "Wed", value: "wednesday" },
        { text: "Thu", value: "thursday" },
        { text: "Fri", value: "friday" },
        { text: "Sat", value: "saturday" },
        { text: "Sun", value: "sunday" },
      ],
      alldays: [
        { text: "Monday", value: "monday" },
        { text: "Tuesday", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursday", value: "thursday" },
        { text: "Friday", value: "friday" },
        { text: "Saturday", value: "saturday" },
        { text: "Sunday", value: "sunday" },
      ],
      current: "monday",
      sidebarTitle: "Add Session",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      dataloading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      fields: [
        { label: "class", key: "name" },
        { label: "section", key: "section" },
        { label: "subject", key: "subject" },
        { label: "start time", key: "startTime" },
        { label: "end time", key: "endTime" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: null,
      timetable: {
        id: 0,
        tID: 0,
        campusID: this.$store.state.userData.cId,
        day: "",
        clsID: 0,
        section: 0,
        subID: 0,
        startTime: "",
        endTime: "",
      },
      myObj: {
        timetable: {},
        days: [],
      },
      classes: [],
      classesOptions: [],
      admittedSections: [],
      subjects: [],
      adding: false,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    back() {
      this.$router.go(-1);
    },

    getLabel(key) {
      const isHappiness = this.isHappiness;
      const map = {
        class: isHappiness ? "group" : "class",
        classes: isHappiness ? "groups" : "classes",
        section: isHappiness ? "level" : "section",
        sections: isHappiness ? "levels" : "sections",
      };
      const result = map[key.toLowerCase()] ?? key.toLowerCase();
      const isCapitalized =
        key[0] === key[0].toUpperCase() && key[0] !== key[0].toLowerCase();
      return isCapitalized
        ? result.charAt(0).toUpperCase() + result.slice(1)
        : result;
    },

    async Edit(obj) {
      // console.log(obj);
      this.timetable = obj;
      this.adding = false;
      this.visibility = true;
      this.sidebarTitle = "Edit Time Table";
      this.sidebarButton = "Update";
      this.FillSections();

      this.$nextTick(() => {
        var elem = this.$refs["class"];
        elem.state = undefined;
        var elem = this.$refs["subject"];
        elem.state = undefined;
        var elem = this.$refs["section"];
        elem.state = undefined;
        var elem = this.$refs["startTime"];
        elem.state = undefined;
        var elem = this.$refs["endTime"];
        elem.state = undefined;
        var elem = this.$refs["editDay"];
        elem.state = undefined;
      });
    },

    AddOpen() {
      this.adding = true;
      this.timetable = {
        id: 0,
        tID: parseInt(this.$route.params.id),
        day: "",
        clsID: 0,
        section: 0,
        subID: 0,
        startTime: "",
        endTime: "",
        campusID: this.$store.state.userData.cId,
      };
      this.sidebarTitle = "Add Time Table";
      this.sidebarButton = "Save";
      this.visibility = true;

      this.$nextTick(() => {
        var elem = this.$refs["class"];
        elem.state = undefined;
        var elem = this.$refs["subject"];
        elem.state = undefined;
        var elem = this.$refs["section"];
        elem.state = undefined;
        var elem = this.$refs["startTime"];
        elem.state = undefined;
        var elem = this.$refs["endTime"];
        elem.state = undefined;
        var elem = this.$refs["days"];
        elem.state = undefined;
      });
    },
    FillSections() {
      // console.log(this.timetable.clsID);
      // this.teachingClassObj.sections = [];
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.timetable.clsID) {
          if (elem.sections.length != 0) {
            // console.log("not null");
            this.admittedSections = elem.sections;
          } else {
            // console.log("null");
            this.admittedSections = [];
          }
        }
      });
      // console.log("Thisis", this.admittedSections);
    },
    CheckClass() {
      var elem = this.$refs["class"];
      if (this.timetable.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSection() {
      // console.log(this.timetable.section);
      var elem = this.$refs["section"];
      if (this.timetable.section === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSubject() {
      var elem = this.$refs["subject"];
      if (this.timetable.subID === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDays() {
      if (this.adding) {
        // console.log(this.myObj.days);
        var elem = this.$refs["days"];
        if (this.myObj.days.length === 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else {
        // console.log(this.timetable.day);
        var elem = this.$refs["editDay"];
        if (this.timetable.day === "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      }
    },
    CheckStartTime() {
      var elem = this.$refs["startTime"];
      if (this.timetable.startTime === "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEndTime() {
      var elem = this.$refs["endTime"];
      if (this.timetable.endTime === "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.session == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },
    async LoadInfo() {
      this.dataloading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.classes = myitem;
      this.classesOptions = this.classes.map((el) => el.cls);

      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj);
      // console.log("sub:", this.subjects);
      this.dataloading = false;
    },
    async LoadData(filterDay) {
      // console.log(filterDay);
      this.current = filterDay;
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "TimeTable/LoadData?tID=" +
          this.$route.params.id +
          "&day=" +
          filterDay +
          "&db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };

      this.items = await this.get(obj);
      if (this.items.length != 0) {
        this.totalRows = this.items.length;
      }
      this.dataLoading = false;
      // console.log("timetable", this.items);
    },

    async Add() {
      this.CheckClass();
      this.CheckSubject();
      this.CheckSection();
      this.CheckDays();
      this.CheckEndTime();
      this.CheckStartTime();
      if (
        this.CheckClass() == false ||
        this.CheckSection() == false ||
        this.CheckSubject() == false ||
        this.CheckDays() == false ||
        this.CheckEndTime() == false ||
        this.CheckStartTime() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        // console.log(this.timetable);
        if (this.timetable.id == 0) {
          //Add
          this.myObj.timetable = this.timetable;
          this.request = true;
          // console.log("obj:", this.myObj);
          var status = await this.post({
            url:
              this.$store.state.domain +
              "TimeTable/save?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Time Table added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData(this.myObj.days[0]);
        } else {
          //Edit
          this.request = true;
          // console.log("edit_obj:", this.timetable);
          var status = await this.put({
            url:
              this.$store.state.domain +
              "TimeTable/" +
              this.timetable.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.timetable,
            message: "Time Table updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData(this.timetable.day);
        }
      }
    },

    async Delete(obj) {
      // console.log(obj);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "TimeTable/" +
            obj.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Time Table removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData(obj.day);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
